import styled from "styled-components";

export const Wrapper = styled.div`
  .image-col {
    height: 25vh;
  }
  .banner-image {
    object-fit: cover;
    border-radius: 4px;
    object-position: bottom;
    width: 100%;
    height: 100%;
  }
  .main-user-col {
    height: auto;
  }

  .plus-icon-div {
    position: relative;
    top: -110px;
    left: 130px;
    z-index: 1;
  }

  .plus-icon {
    font-size: 30px;
    background-color: #fff;
    border-radius: 30px;
  }
  .user-image-before {
    position: relative;
    object-fit: cover;
    top: -75px;
    left: -20px;
    width: 150px;
    height: 150px;
    background-color: #fff;
    border-radius: 50%;
  }
  .user-image {
    position: relative;
    object-fit: cover;
    top: -75px;
    left: -20px;
    width: 150px;
    height: 150px;
    background-color: #fff;
    border-radius: 50%;
    border: 4px solid black;
  }

  .main-user-image-col {
    display: flex;
    align-items: center;
    height: auto;
  }
  .user-name-row {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    margin-bottom: 10px;
  }
  .user-name-text {
    font-weight: bold;
    font-size: 20px;
    width: 350px;
  }
  .location-container {
    display: flex;
    align-items: flex-start;
  }
  .user-address {
    padding-left: 5px;
    font-size: 15px;
    font-weight: bold;
  }
  .vector-image {
    width: 17px;
  }
  .main-section-container{
    width: 350px;
    position: relative;
    top: -160px;
    left: 160px;
  }
  @media screen and (max-width: 1000px) {
    .main-section-container{
      top: 0px;
    }
    .main-user-col {
      height: auto;
    }
    .user-data-col {
      margin-top: -160px; 
      margin-left: 16px; 
    }
    .user-name-row {
      margin-left: 0px !important;
    }
  }
  @media screen and (max-width: 600px){
    .user-image {
    position: relative;
    object-fit: cover;
    top: -60px;
    left: -20px;
    width: 120px;
    height: 120px;
    background-color: #fff;
    border-radius: 50%;
    border: 4px solid black;
  }
  .plus-icon-div {
    position: relative;
    top: -100px;
    left: 100px;
    z-index: 1;
  }
  .user-data-col {
      margin-top: -130px; 
      margin-left: -15px; 
    }
    .vector-image {
    width: 15px;
  }
  .user-name-text {
    font-weight: bold;
    font-size: 14px;
  }
  .user-address{
    font-size: 13px;
  }
  }
`;

export const ProfileWrapper = styled.div`
  padding-left: 15px;
  position: relative;
    top: -130px;
  .label-container {
    font-size: 17px;
    font-weight: bold;
  }
  .text-container {
    font-size: 14px;
  }
  @media screen and (max-width: 1000px){
    top: -70px;
  }
`;
